module.exports = __webpack_public_path__ + "img/etalon.2a805c93.png";